import { render, staticRenderFns } from "./RegistrationFooter.vue?vue&type=template&id=7be5dd41&"
import script from "./RegistrationFooter.vue?vue&type=script&lang=ts&"
export * from "./RegistrationFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports